import { render, staticRenderFns } from "./Desanexar.vue?vue&type=template&id=7012db28&scoped=true"
import script from "./Desanexar.vue?vue&type=script&lang=js"
export * from "./Desanexar.vue?vue&type=script&lang=js"
import style0 from "./Desanexar.vue?vue&type=style&index=0&id=7012db28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012db28",
  null
  
)

export default component.exports